import { useMemo } from "react";

import { PracticeCropWithDefaults } from "utils";

import { CropYear } from "pages/app/scenario-analysis/types/scenario";
import { GenerateChangeScenarioResult, buildCropCalendarInfoById, generateChangeScenario } from "pages/app/scenario-onboarding/utils/changeScenarioGenerator";

/** Regenerates only on a new baseline, so a catalogue refetch can't reshuffle the highlights mid-session. */
export const useStableGeneratedChangeScenario = (
  cropYears: CropYear[],
  practiceCrops: PracticeCropWithDefaults[] | undefined,
  currentYear: number
): GenerateChangeScenarioResult => {
  // Keyed on arrival, not identity, so a refetch returning a new array reuses the memo.
  const isCatalogueLoaded = !!practiceCrops;

  return useMemo(
    () => generateChangeScenario(cropYears, buildCropCalendarInfoById(practiceCrops), currentYear),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- practiceCrops is keyed via isCatalogueLoaded.
    [cropYears, isCatalogueLoaded, currentYear]
  );
};
